
import { memo } from "react";

import { IonCol, IonGrid, IonLabel, IonRow, IonText } from "@ionic/react";

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Autocomplete } from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";

import PhoneInput from 'react-phone-input-2';
import es from 'react-phone-input-2/lang/es.json'

import { timeZones, pais } from '../../../helpers';

import 'react-phone-input-2/lib/material.css';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
        },
        button: {
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        actionsContainer: {
            marginBottom: theme.spacing(2),
        },
        resetContainer: {
            padding: theme.spacing(3),
        },
    }),
);

const DatosInstitucion = ({
    setRolTypeRegister,
    handleNext,
    handleBack,
    formik: {
        errors,
        touched,
        setTouched,
        setFieldValue,
        values,
        handleChange,
    } }: any) => {

    //console.log({ errors, values })

    const classes = useStyles();

    return (
        <>
            <IonGrid className="ion-padding-none">
                <IonRow>

                    <IonCol className="ion-text-center" size="12">
                        <img
                            src={process.env.PUBLIC_URL + '/assets/img/steps/002-school.png'}
                            height={120}
                            alt=""
                        />
                    </IonCol>

                    <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Nombre de la institución"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosInstitucion.nombre"}
                            name={"Escuela.DatosInstitucion.nombre"}
                            value={values.Escuela.DatosInstitucion.nombre}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        nombre: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosInstitucion?.nombre && errors?.Escuela?.DatosInstitucion?.nombre}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        />
                    </IonCol>


                    <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12" style={{ display: 'none' }}>
                        <TextField
                            label="Descripción"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosInstitucion.descripcion"}
                            name={"Escuela.DatosInstitucion.descripcion"}
                            value={values.Escuela.DatosInstitucion.descripcion}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        descripcion: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosInstitucion?.descripcion && errors?.Escuela?.DatosInstitucion?.descripcion}
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            multiline
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="4" sizeMd="4" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Calle"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosInstitucion.direccion"}
                            name={"Escuela.DatosInstitucion.direccion"}
                            value={values.Escuela.DatosInstitucion.direccion}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        direccion: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosInstitucion?.direccion && errors?.Escuela?.DatosInstitucion?.direccion}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="2" sizeMd="2" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Número"
                            type="text"
                            inputMode="numeric"
                            id={"Escuela.DatosInstitucion.numero"}
                            name={"Escuela.DatosInstitucion.numero"}
                            value={values.Escuela.DatosInstitucion.numero}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        numero: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosInstitucion?.numero && errors?.Escuela?.DatosInstitucion?.numero}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        //inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                        />
                    </IonCol>

                    <IonCol sizeXl="4" sizeMd="4" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Colonia / Barrio/ Zona"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosInstitucion.colonia"}
                            name={"Escuela.DatosInstitucion.colonia"}
                            value={values.Escuela.DatosInstitucion.colonia}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        colonia: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosInstitucion?.colonia && errors?.Escuela?.DatosInstitucion?.colonia}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="2" sizeMd="2" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Código postal"
                            type="text"
                            inputMode="numeric"
                            id={"Escuela.DatosInstitucion.cp"}
                            name={"Escuela.DatosInstitucion.cp"}
                            value={values.Escuela.DatosInstitucion.cp}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        cp: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosInstitucion?.cp && errors?.Escuela?.DatosInstitucion?.cp}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            inputProps={{
                                maxLength: 5,
                                inputMode: 'numeric',
                                pattern: '[0-9]*',
                            }}
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Estado / Ciudad"
                            type="text"
                            inputMode="text"
                            id={"Escuela.DatosInstitucion.edo"}
                            name={"Escuela.DatosInstitucion.edo"}
                            value={values.Escuela.DatosInstitucion.edo}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        edo: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosInstitucion?.edo && errors?.Escuela?.DatosInstitucion?.edo}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        />
                    </IonCol>

                    <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
                        <Autocomplete
                            id={"Escuela.DatosInstitucion.pais"}
                            options={pais}
                            getOptionLabel={(value: string) => value}
                            style={{ width: '100%', height: '100%' }}
                            color="primary"
                            value={values.Escuela.DatosInstitucion.pais}
                            onChange={(_, value) => {
                                setFieldValue('Escuela.DatosInstitucion.pais', value)
                                return setRolTypeRegister(value);
                            }}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        pais: true
                                    }
                                }
                            })}
                            //disabled={showLoading}
                            noOptionsText="Sin resultados"
                            renderInput={(params: any) => {
                                return (
                                    <TextField
                                        {...params}
                                        label="País"
                                        name={"Escuela.DatosInstitucion.pais"}
                                        error={touched?.Escuela?.DatosInstitucion?.pais && errors?.Escuela?.DatosInstitucion?.pais}
                                        id="outlined-error-helper-text"
                                        variant="outlined"
                                        size="medium"
                                        margin="normal"
                                        fullWidth
                                        required
                                    />
                                )
                            }}
                        />
                    </IonCol>


                    <IonCol sizeXl="4" sizeMd="4" sizeSm="12" sizeXs="12">
                        <PhoneInput
                            inputProps={{
                                name: 'Teléfono',
                                required: true,
                                autoFocus: true
                            }}
                            localization={es}
                            country={'mx'}
                            enableSearch={true}
                            placeholder="Teléfono"
                            specialLabel="Teléfono"
                            searchPlaceholder="Buscar país"
                            searchNotFound="Sin resultados"
                            value={values.Escuela.DatosInstitucion.telefono}
                            onChange={(e: string) => setFieldValue("Escuela.DatosInstitucion.telefono", e)}
                            regions={['america']}
                            autocompleteSearch={true}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        telefono: true
                                    }
                                }
                            })}
                            isValid={(value, country: any) => {
                                if (value.match(/12345/)) {
                                    return 'Numero invalido: ' + value + ', ' + country.name;
                                } else if (value.match(/1234/)) {
                                    return false;
                                } else {
                                    return true;
                                }
                            }}
                        />
                    </IonCol>

                    <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12" className="ion-padding">
                        <IonLabel
                            style={{ fontSize: '1rem' }}
                            color={touched?.Escuela?.DatosInstitucion?.logo && errors?.Escuela?.DatosInstitucion?.logo ? 'danger' : ''}
                        >
                            {errors?.Escuela?.DatosInstitucion?.logo ?? 'Logo (opcional)'}
                        </IonLabel>
                        <br /><br />
                        <input
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            id={"Escuela.DatosInstitucion.logo"}
                            name={"Escuela.DatosInstitucion.logo"}
                            onChange={(e: any) => setFieldValue("Escuela.DatosInstitucion.logo", e.currentTarget.files[0])}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        logo: true
                                    }
                                }
                            })}
                            required
                        />
                    </IonCol>

                    <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Número de alumnos"
                            type="number"
                            inputMode="numeric"
                            id={"Escuela.DatosInstitucion.numero_alumnos"}
                            name={"Escuela.DatosInstitucion.numero_alumnos"}
                            value={values.Escuela.DatosInstitucion.numero_alumnos}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        numero_alumnos: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosInstitucion?.numero_alumnos && errors?.Escuela?.DatosInstitucion?.numero_alumnos}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                            inputProps={{
                                inputMode: 'numeric',
                                pattern: '[0-9]*',
                                type: 'number',
                                min: 12,
                            }}
                        />
                    </IonCol>


                    <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
                        <Autocomplete
                            id={"Escuela.DatosInstitucion.zona_horaria"}
                            options={timeZones}
                            getOptionLabel={(value: string) => value}
                            style={{ width: '100%', height: '100%' }}
                            color="primary"
                            value={values.Escuela.DatosInstitucion.zona_horaria}
                            onChange={(_, value) => setFieldValue('Escuela.DatosInstitucion.zona_horaria', value)}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        zona_horaria: true
                                    }
                                }
                            })}
                            //disabled={showLoading}
                            noOptionsText="Sin resultados"
                            renderInput={(params: any) => {
                                return (
                                    <TextField
                                        {...params}
                                        label="Franja horaria (país/cuidad)"
                                        name={"Escuela.DatosInstitucion.zona_horaria"}
                                        error={touched?.Escuela?.DatosInstitucion?.zona_horaria && errors?.Escuela?.DatosInstitucion?.zona_horaria}
                                        id="outlined-error-helper-text"
                                        variant="outlined"
                                        size="medium"
                                        margin="normal"
                                        fullWidth
                                        required
                                    />
                                )
                            }}
                        />
                    </IonCol>


                    <IonCol sizeXl="12" sizeMd="12" sizeSm="12" sizeXs="12">
                        <TextField
                            label="Hora de salida"
                            type="time"
                            id={"Escuela.DatosInstitucion.hora_salida"}
                            name={"Escuela.DatosInstitucion.hora_salida"}
                            value={values.Escuela.DatosInstitucion.hora_salida}
                            onChange={handleChange}
                            onBlur={() => setTouched({
                                ...touched,
                                Escuela: {
                                    ...touched?.Escuela?.DatosInstitucion,
                                    DatosInstitucion: {
                                        ...touched?.Escuela?.DatosInstitucion,
                                        hora_salida: true
                                    }
                                }
                            })}
                            error={touched?.Escuela?.DatosInstitucion?.hora_salida && errors?.Escuela?.DatosInstitucion?.hora_salida}
                            required
                            variant="outlined"
                            size="medium"
                            margin="normal"
                            fullWidth
                        />
                    </IonCol>


                    <div className={classes.actionsContainer}>
                        <div className="ion-padding">

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleNext}
                                className={classes.button}
                                // || !touched.Escuela.hasOwnProperty('DatosInstitucion')
                                disabled={errors?.Escuela?.hasOwnProperty('DatosInstitucion')}
                            >
                                Siguiente
                            </Button>
                        </div>
                    </div>

                </IonRow>

            </IonGrid>

        </>

    );
};

export default memo(DatosInstitucion);